import PaymentIframeInputUi from './PaymentIframeInputUi';

export default PaymentIframeInputUi;
